import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson13: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson12"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">Finance Budget</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson14"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[9.63rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] text-white font-dm-sans">

        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>What Is Your Income</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Your Income is the source of money you have to work with every
                month.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Each month you have ends and bills to meet.</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Income is your only working resource to make ends meet. Living
                  Expenses:
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Living Expenses drain "Income".</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Many times living expenses are built upon bad decision-making.
                  Lifestyle Expenses:
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Many people tend to live above their income even though they
                  cannot maintain it.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Placing Lifestyle OVER Living Expenses is the #1 reason why
                  you are struggling to make "Ends".
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  This will also carry over to your trading and impact your
                  trades and decision-making process.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>What Are Your Ends?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Your Ends are the cost of money you have to spend every month.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>What does your life cost each month?</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Figure out each and everything that you are paying each month
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Consider if those “expenses” are necessary or not. `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Then determine a monthly budget. `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Excess Expenses = Unnecessary Stress `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Stress impacts your trades and decision-making process. `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Poor decision-making leads towards entering bad trades that you regret seconds later. `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Complete the Following `}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Write down every expense that has to be met by the end of the month. `}</span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Sort out each expense into an “Required Expense” or “Excess
                  Expense”.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Income VS Monthly Expenses</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  An “end” within this list is causing you to stumble within
                  your Trading Career.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Find out what is causing it because that is the source of
                  making bad trading decisions
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Categorize each expense with the following:</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Know which expense is a “NEED/MUST” `}</span>
              </span>
            </li>
            <li>
              <span>
                <span>Know which expense is “excess and trim it.”</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Source of Income</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li>
              <span>
                <span>Trading, Business or Job</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Ends</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li>
              <span>
                <span>{`Rent, Transportation, Utilities, Health Care, Food, Family/Children, Clothing & Entertainment`}</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Trading VS Ends</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>{`Every time you are trading, you are bringing your ENDS with you. Causing emotions such a Stress, Fear, Uncertainty & Anxiety`}</span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[9.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Creating A Budget</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  A budget is a spending plan based on income and expenses for a
                  defined period of time. It can include planned sales volumes
                  and revenues, costs and expenses, assets, liabilities, and
                  cash flows.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  While following a budget might seem to be limiting, if used as
                  a guide it can be incredibly helpful. In order to make smart
                  financial decisions both in crypto and out, it's important you
                  have a good understanding of your monthly savings, and
                  spending habits.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[24.5rem] object-cover"
            alt=""
            src="/i54@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          Creating the proper budget takes time as you should account for all of
          the spending decisions you make. Daily spending affects your long-term
          financial goals. If you already have budgeted before it is always
          smart to periodically revisit your budgeting plan and consistently
          adjust it to reflect your current life situation.
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>5 Step Budgeting Process</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Determine your average monthly income</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Identify your total fixed expenses</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Estimate your variable expenses</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Calculations and Adjusting</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>List Priorities and Track Progress</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>We will break down each step below.</span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[9.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Determine Your Average Monthly Income</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Average Monthly Income is the total amount of money you earn
                  in a month after deductions.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  For some, this may simply be reviewing your after-tax
                  take-home pay on your paycheck. However, there are many cases
                  where you can have additional sources of income that need to
                  be taken into account.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  To be on the more conservative side use the months with your
                  lowest income to get your average.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[22rem] object-cover"
            alt=""
            src="/i55@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          If you are self-employed remember to deduct the estimated taxes owed
          from gross income in order to get a more accurate average.
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[9.63rem] text-[1.56rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b className="text-[1.88rem] font-dm-sans">
                <span className="text-gainsboro-100">Id</span>
                <span className="text-white">
                  entify Your Total Fixed Expenses
                </span>
              </b>
            </p>
            <p className="m-0">
              <span>
                <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Fixed expenses are your regular expenses that normally don’t
                  change much from month to month.
                </span>
              </span>
            </p>
            <p className="m-0">
              <a
                className="text-[inherit]"
                href="https://www.marketing91.com/wp-content/uploads/2018/02/Fixed-Expenses-3.jpg"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">&nbsp;</span>
                  </span>
                </span>
              </a>
            </p>
            <p className="m-0">
              <span>
                <span>Some examples of fixed expenses can include:</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Rent/Mortgage</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Utility bills - water, electricity, internet and cell phone
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Insurance</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Transportation costs - fares, gas and maintenance</span>
                </span>
              </li>
              <li>
                <span>
                  <span>Debt payments - loans</span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[42.81rem] h-[22rem] object-cover"
            alt=""
            src="/i56@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          It would also be smart to consider any contributions to your savings
          as a fixed expense. When you set a percentage/amount to save the
          amount you can treat it as a bill you are paying hence a fixed
          expense. This approach is great for overall savings and budgeting
          habits.
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[9.63rem] text-[1.56rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b className="text-[1.88rem] font-dm-sans">
                <span className="text-white">
                  Estimate Your Variable Expenses
                </span>
              </b>
            </p>
            <p className="m-0">
              <span>
                <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Variable expenses are those expenses that fluctuate from month
                  to month.
                </span>
              </span>
            </p>
            <p className="m-0">
              <a
                className="text-[inherit]"
                href="https://www.marketing91.com/wp-content/uploads/2018/02/Fixed-Expenses-3.jpg"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">&nbsp;</span>
                  </span>
                </span>
              </a>
            </p>
            <p className="m-0">
              <span>
                <span>Some examples of what they can include are:</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Entertainment - movies, amusement parks and video games
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Eating Out</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Shopping</span>
                </span>
              </li>
              <li>
                <span>
                  <span>Travel</span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[42.81rem] h-[24.06rem] object-cover"
            alt=""
            src="/i57@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            With these changing ever so often it might be harder for you to
            identify.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            A tip we recommend is look at your past credit card bills to gain a
            sense of a rough estimate of how much you spend in each category. Be
            sure you also keep track of any cash purchases as well.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Remember to keep in mind these types of expenses don't happen every
            month. So better way to account for them is by estimating how much
            they cost you on an annual basis. Then you can divide past yearly
            annual costs by 12 and get a rough monthly estimate to
            conservatively budget for them.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[9.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Calculations and Adjustments</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Now that you have all of your expenses and your average
                  monthly income you can calculate and make any adjustments
                  necessary.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Deduct your variable and fixed expenses from your monthly
                  income. If you have a negative number you need to alter your
                  variable expenses. If you have a positive number then great
                  you have enough expendable capital to where you can begin
                  looking to adjust your budget for crypto investing.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[24.06rem] object-cover"
            alt=""
            src="/i58@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[9.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>List Priorities and Track Progress</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Create a list of your top priorities to help you figure out
                  how you’ll use any extra funds in your budget after all
                  necessary expenses. Is crypto investing included in your top
                  priorities list?
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  If not, you should include it as a priority if you aim to
                  include it as part of your budget.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Keep yourself on track by periodically monitoring your overall
                  budget.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[19.25rem] object-cover"
            alt=""
            src="/i59@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[9.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Final Points</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  A good framework for budgeting should start by following the
                  50/30/20 rule.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  50% for needs, 30% for wants and 20% for savings/debt
                  repayment
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  It's important to remember that along with your financial
                  situation your crypto investment goals can and will change.
                  Annually do a full review of your budgeting plan. This will
                  allow you to see if you have any extra money at end of the
                  year you can put towards crypto investing.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Even with inflation as high as it currently is, establishing a
                  budgeted investing discipline early is extremely valuable.
                  Being able to alter your budget accordingly to your financial
                  plan will have its long-term portfolio benefits. Consistency
                  is key with money management!
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[42.81rem] object-cover"
            alt=""
            src="/i60@2x.png"
          />
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson14">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson13;
